import { useTheme } from "@hooks";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    anchor: {
      color: theme.link.secondary,
      fontWeight: 700,
      cursor: "pointer",
      textDecoration: "none",
    },
  };

  return styles;
};
